<template>
  <button type="button" role="button" class="type-button"
          :class="active ? classFromColorIndex(colorIndex, 'bg-primary', 'bg-secondary'): 'bg-gray'"
          @click="$emit('click')">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      required: true
    },
    colorIndex: {
      type: Number,
      default: 0
    }
  },

  emits: ['click']
}
</script>

<style lang="scss" scoped>
.type-button {
  padding: 3px 8px;
  border-radius: 15px;
  border: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: small;
  font-weight: bold;
  color: white;

  &:not(:last-child){
    margin-right: 10px;
  }
}

.bg-gray {
  background: #CCCCCC;
}
</style>
